import { render, staticRenderFns } from "./NoResults.vue?vue&type=template&id=da805cf0&scoped=true&"
import script from "./NoResults.vue?vue&type=script&lang=js&"
export * from "./NoResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da805cf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.clcp.cliquedomains.com/web/app/themes/clc-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da805cf0')) {
      api.createRecord('da805cf0', component.options)
    } else {
      api.reload('da805cf0', component.options)
    }
    module.hot.accept("./NoResults.vue?vue&type=template&id=da805cf0&scoped=true&", function () {
      api.rerender('da805cf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/vue/Components/Blocks/NoResults.vue"
export default component.exports